import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms62e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres62e/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtereq_st: (typeof searchParams.dtereqst.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqst.replace(/\//g, '') : ''),
        p_dtereq_en: (typeof searchParams.dtereqen.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqen.replace(/\//g, '') : ''),
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
        p_codempid_query: ((typeof searchParams.codempid !== 'undefined' && searchParams.codempid !== '') ? searchParams.codempid : '%')
      }
    } else {
      sendParams = {
        p_codcomp: '',
        p_codempid_query: '%'
      }
    }
    return instance().get(endpoint + '/hres62e/index', { params: sendParams })
  },
  getCreate (searchDetail) {
    let sendParams = {
      p_dtework: searchDetail.dtework,
      p_codempid_query: searchDetail.codempid_query
    }
    if (isMock) return generator(mocker.create())
    return instance().get(endpoint + '/hres62e/create', { params: sendParams })
  },
  getDetail (searchDetail) {
    let sendParams = {
      p_dtereq: searchDetail.dtereq,
      p_numseq: searchDetail.seqno,
      p_codempid_query: searchDetail.codempid_query
    }
    if (isMock) return generator(mocker.detail())
    const params = sendParams.p_dtereq.replace(/\//g, '') + '/' + sendParams.p_numseq + '/' + sendParams.p_codempid_query
    return instance().get(endpoint + '/hres62e/update/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres62e/dropdowns')
  },
  getPopup (popupParams) {
    let searchParams = {
      p_codleave: popupParams.codleave
    }
    const params = searchParams.p_codleave
    if (isMock) return generator(mocker.popup())
    return instance().get(endpoint + '/hres62e/getPopup/' + params)
  },
  getCodleave (searchParams) {
    if (isMock) return generator(mocker.getCodleave())
    const params = searchParams.p_dtework.replace(/\//g, '') + '/' + searchParams.p_codempid_query
    return instance().get(endpoint + '/hres62e/getCodleave/' + params)
  },
  postSave ({ saveParams, searchParams }) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres62e/update', saveParams)
  },
  postCancel ({ cancelParams, searchParams }) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hres62e/cancel', cancelParams)
  },
  getEntitleFlagLeave (searchParams) {
    if (isMock) return generator(mocker.entitleFlagLeave())
    return instance().post(endpoint + '/hres62e/entitleFlagLeave', searchParams)
  },
  getWorktime (searchParams) {
    if (isMock) return generator(mocker.worktime())
    return instance().get(endpoint + '/hres62e/workTime', { params: searchParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms62e/index.js